<template>
    <div class="symmetry_blue">
        <h3><span class="first-with-short-rule">Account Grants</span></h3>
        <div class="account-grants-actions">
            <v-btn class="flex-shrink-0" outlined color="primary" left @click="startNewGrant">
				Add New <v-icon right>fas fa-plus</v-icon>
            </v-btn>
            <p class="account-grants-instruction body-2" v-html="instruction" />
        </div>
        <p>The following users have access to your account and can view all data associated with your account. They can also do work on your behalf, like add support tickets or create admin notices.</p>
        <q-account-grants-data-table class="mx-n4" title="Account Grants" :agent="agent" ref="grant_table"></q-account-grants-data-table>
        <v-dialog v-model="showNewGrantDialog" width="450px" max-width="90%">
            <v-card class="pa-4">
                <v-card-title>
                    <h4 class="q-display-1 pa-5 white--text text-center q_leads_1" style="min-width:100%;">New Grant</h4>
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="account_grant.name" label="Full Name"></v-text-field>
                    <v-text-field v-model="account_grant.email" label="Email"></v-text-field>
                </v-card-text>
                <v-card-actions class="text-center">
                    <v-spacer></v-spacer>
                    <v-progress-circular indeterminate v-if="savingGrant"></v-progress-circular>
                    <v-btn v-else color="primary" large @click="createAccountGrant">Add</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import QuilityAPI from '@/store/API/QuilityAPI.js'
import QAccountGrantsDataTable from '@/components/datatables/QAccountGrantsDataTable.vue'
export default {
    name: "QAccountGrants",
    props: ['agent'], // data passed to component from parent
    data: function() { // data internal to component (not available outside)
        return {
            savingGrant: false,
            showNewGrantDialog: false,
            account_grant: {
                name: null,
                email: null,
            },
			instruction: "When creating new grants to your HQ profile, if the user's email address does not already exists in HQ, a new account will be created and a Welcome to HQ email will be sent to them. Examples could be administrative or contracting staff. If the email address does exist in HQ, for example an agent or advisor who is already accessing HQ to do business, a <strong>different</strong> email address should be used for account grant access to your HQ profile.",
        }
    },
    methods: {
        createAccountGrant () {
            this.savingGrant = true
            QuilityAPI.createAccountGrant(this.account_grant.email, this.account_grant.name)
				.then((json) => {
					if (json.error) {
						this.showError(json.msg)
					} else {
						this.$refs.grant_table.refreshData()
						this.showNewGrantDialog = false
					}
				})
				.catch((err) => {
					this.showError('Opps, something went wrong.<br>', err.msg || err.message || err.response?.body?.message)
				})
				.finally(() => {
					this.savingGrant = false
				})
        },
        startNewGrant: function() {
            this.account_grant = {
                name: null,
                email: null,
            }
            this.showNewGrantDialog = true;
        }
    },
    components: {
        QAccountGrantsDataTable
    }
}
</script>

<style lang="scss" scoped>
.account-grants-actions {
	margin-bottom: 1.5rem;
	display: flex;
	flex-wrap: wrap;
	gap: 1rem 2rem;
}

.account-grants-instruction {
	flex: 1 1 320px;
	max-width: 800px;
}
</style>
